import React, { useEffect, useMemo, useState } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { TableTab } from '@models/document/IDocumentScheme';
import { IFieldElem } from '@models/IFormData';
import { handlerFieldWatch } from '@utils/fieldWatchUtils';
import { FormulaManager } from '@utils/managers/FormulaManager';
import Box from '@atoms/Box';
import './DocumentTabAttachTable.scss';
import DocumentAttachTable from '@organisms/document/DocumentTabBuilder/tabs/DocumentTabAttach/DocumentAttachTable';

export interface IDocumentTabAttachTableProps<TFieldValues extends object = object> {
    attachTable?: TableTab;
    formMethods: UseFormReturn<TFieldValues>;
    isEdit: boolean;
    isNew: boolean;
    fields: Record<string, IFieldElem>;
    docId: string;
}

const DocumentTabAttachTable = <TFieldValues extends object = object>({
    attachTable,
    formMethods,
    isEdit,
    isNew,
    fields,
    docId,
}: IDocumentTabAttachTableProps<TFieldValues>) => {
    const visibilityRules = attachTable?.visibilityRules;
    const visibilityMng = useMemo(() => {
        const manager = new FormulaManager(visibilityRules!);
        manager.Init(fields, formMethods);
        return manager;
    }, [visibilityRules, fields, formMethods]);

    const activated = React.useRef(false);
    const [visibility, setVisibility] = useState<boolean>(false);
    const InitFormulas = async () => {
        let result = await visibilityMng.EvalFormulaValues(isEdit, isNew);
        if (activated.current) {
            setVisibility(result);
        }
    };
    useEffect(() => {
        activated.current = true;
        InitFormulas();
        return () => {
            activated.current = false;
        };
    }, []);
    const watch = useWatch({
        name: visibilityMng.GetWatchFields(),
    });

    useEffect(() => {
        handlerFieldWatch(watch, isEdit, isNew, visibilityMng, setVisibility, activated);
    }, [watch, isEdit, isNew]);

    return attachTable && visibility ? (
        <Box header={attachTable.name} key={`box_${attachTable.key}`}>
            <DocumentAttachTable attachTable={attachTable} docId={docId} />
        </Box>
    ) : (
        <></>
    );
};

export default DocumentTabAttachTable;
